import { render } from "./AdminManage.vue?vue&type=template&id=a95b1f00&scoped=true"
import script from "./AdminManage.vue?vue&type=script&lang=js"
export * from "./AdminManage.vue?vue&type=script&lang=js"

import "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&external"
import "./AdminManage.vue?vue&type=style&index=1&id=a95b1f00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a95b1f00"]])

export default __exports__